<template>
  <div class="row" style="padding: 5px">
    <div class="col-12 mb-4">
      <div class=" pb-4">
        <v-btn @click="redirectByUrl('/admin/services')" outlined style="border: none;background: #fff" title="Retourner">
          <v-icon>mdi mdi-arrow-left</v-icon>
          Les services
        </v-btn>
      </div>
      <v-card elevation="0" class="p-0">
                    <v-card-text class="p-0">
                      <v-form ref="clientForm" v-model="clientFormIsValid">                         
                          <h4 style="font-weight:bold" class="mt-5 mb-5">
                            Définir les champs d'acquisition du service
                          </h4>
                          <div v-for="(record,index) of payload" :key="index">
                            
                          <div class="col-12 mb-2" style="background : #fff" >
                          <v-row>
                            <div class="col-12 text-right">
                              <button class="btn btn-danger btn-sm" type="button" @click="removeChamps(index)"><v-icon small class="mr-0 pr-0" style="color:#fff">mdi-trash-can-outline</v-icon></button>
                            </div>
                            <v-col :lg="payload[index].type==='file' || payload[index].type=== 'image' ? 4 : 6" sm="12">
                              <label for="">Nom du champ</label>
                              <v-text-field solo
                                            :rules="requiredRules"
                                            label="Nom"
                                            v-model="payload[index].name"
                              ></v-text-field>
                            </v-col>
                              <v-col :lg="payload[index].type==='file' || payload[index].type==='image'  ? 4 : 6" sm="12">
                              <label for="">Type</label>
                              <v-autocomplete solo
                                              :items="type_champs"
                                              item-text="name"
                                              v-model="payload[index].type"
                                              item-value="type"
                                            :rules="requiredRules"
                                            placeholder="Type de champs"
                              ></v-autocomplete>
                            </v-col>
                              <v-col lg="4" sm="12" v-if="payload[index].type==='file' || payload[index].type=== 'image' ">
                              <label for="">Type de fichier</label>
                              <v-autocomplete solo multiple
                                            v-model="payload[index].accept"
                                            :items="payload[index].type==='file' ? file_options : image_options"
                                            :rules="requiredRules"
                                            placeholder="Type de fichier champs"
                              ></v-autocomplete>
                            </v-col>
                             <v-col lg="6" sm="12"  v-if="payload[index].type==='selected' || payload[index].type==='radio' || payload[index].type==='checkbox'">
                              <label for="">Options <v-icon :title="'Exemple : pour liste déroulante et radio =>'+options+'. Utiliser du text simple pour les elements de type text et number.'" small>mdi-help-circle-outline</v-icon> </label>
                              <v-textarea solo rows="2"
                                            :rules="requiredRules"
                                            v-model="payload[index].options"
                              ></v-textarea>
                            </v-col>
                            <v-col :lg="6" sm="12">
                              <label for="">Regex de validation </label>
                              <v-text-field solo
                                            :rules="requiredRules"
                                            label="Validation"
                                            v-model="payload[index].validator"
                              ></v-text-field>
                            </v-col>
                            <v-col :lg="6" sm="12">
                              <label for="">Valeur par défaut </label>
                              <v-text-field solo
                                            :rules="requiredRules"
                                            label="Validation"
                                            v-model="payload[index].default_value"
                              ></v-text-field>
                            </v-col>
                            <v-col :lg="12" sm="12">
                              <label for="">Description</label>
                              <v-textarea solo rows="2"
                                            :rules="requiredRules"
                                            label="valeur par défaut"
                                            v-model="payload[index].description"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          </div>
                          </div>
                          <div class="mt-3 text-center">
                            <v-btn small @click="addChamps()" color="warning">
                              <v-icon small>mdi-plus</v-icon>
                              Ajouter nouveau champ</v-btn> &nbsp;&nbsp;
                          <v-btn color="primary" :loading="submitting" @click="save()" small><v-icon small>mdi-content-save-all-outline</v-icon> Enrégistrer </v-btn>
                          </div>
                      </v-form>
                    </v-card-text>
                  </v-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {mapState} from "vuex";
import GoToParams from "../../administrators/globalComponents/GoToParams";
import {fontAwesomePicker} from 'font-awesome-picker';
import {client} from "../../../store/services/client";
import {env} from "../../../../env";

export default {
  name: "attributes",
  components: {
    GoToParams,
    'font-awesome-picker': fontAwesomePicker,
  },
  data() {
    return {
      submitting:false,
      records:[0],
      services: [],
      modeValidations: [
        {
          id: 1,
          text: 'Manuel'
        },
        {
          id: 2,
          text: 'Automatique via API'
        }
      ],
      sheetrules: [
        value => !value || value.size < 10000000 || 'Avatar size should be less than 10 MB!',
      ],
      page: 0,
      default_payload:{
          name:'',
          type:'',
          validator:'',
          description:'',
          default_value:'',
          options: this.options,
          accept:'',
      },
      payload:[{
          name:'',
          type:'',
          validator:'',
          description:'',
          default_value:'',
          options: this.options,
          accept:'',
      }],
      type_champs_value: 'text',
      type_champs:[
                    {name:'Texte',type:'text'},
                    {name:'Nombre',type:'number'},
                    {name:'Email',type:'email'},
                    {name:'telephone',type:'phone'},
                    {name:'Booléen',type:'boolean'},
                    {name:'Date',type:'date'},
                    {name:'Date et heure',type:'datetime'},
                    {name:'Fichier',type:'file'},
                    {name:'Image',type:'image'},
                    {name:'Liste déroulante',type:'selected'},
                    {name:'Ensemble de cases à cocher',type:'checkbox'},
                    {name:'Ensemble de boutons radio',type:'radio'}           
      ],
      options: "{case1: 'option1 text', case 2 : 'option2 text'}",
      file_options: ['pdf','png','mp4','mp3','mpeg','jpeg','*'],
      image_options: ['png','jpeg','jpg','*'],
      type_name: 'fichier',
      total_pages: 0,
      clientFormIsValid: false,
      requiredRules: [
        v => !!v || 'Ce champ est recquis',
      ],
      loadings: {
        services: false,
      },
      dialogDelete: false,
      country_key: '',
      lazy: false,
      errors: {},
      search: '',
      editingService: false,
      dialogService: false,
      id: undefined,
      headers: [
        {text: '', value: '_logo'},
        {text: 'Nom du service', value: '_nom'},
        {text: 'Mode de validation', value: '_mode_validation'},
        {text: '', value: 'actions', sortable: false},
      ],
      editedIndex: -1,
      editedItem: {},
      user_role: '',
    }
  },
  methods: {
     async get () {
                let VueBox = this;
                let url='/services/attributs'
                const response = await client({
                    method: 'post',
                    url: url,
                    data: {service : this.$route.params.service_slug}
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error)
                        return {
                        error: true
                        }
                    })
                if (response && !response.error){
                    let attributs=response.attributs;
                    VueBox.payload=[];
                    if(attributs.length > 0){
                      attributs.map(res=>{
                      VueBox.payload.push({
                          name:res._name,
                          type:res._type,
                          validator:res._validator,
                          description:res._description,
                          default_value:res._default_value,
                          options: res._options,
                          accept:res._accepted_file
                      })
                    })
                   }else{
                      this.payload=[{
                        name:'',
                        type:'',
                        validator:'',
                        description:'',
                        default_value:'',
                        options: this.options,
                        accept:'',
                    }]
                   }
                }
            },
     async save () {
                let VueBox = this;
                let url='/services/attributs/created'
                this.submitting = true;
                const response = await client({
                    method: 'post',
                    url: url,
                    data: {"values" : JSON.stringify(this.payload), service : this.$route.params.service_slug}
                })
                    .then(res => res.data)
                    .catch(error => {
                        console.log(error)
                        this.submitting = false
                        return {
                        error: true
                        }
                    })
                this.submitting = false
                if (response && !response.error)
                    VueBox.toast('success',this.$t(response.message))
            },
    addChamps(){
      if(!this.payload || this.payload ===null) this.payload=[];
      this.payload.push({
          name:'',
          type:'',
          validator:'',
          description:'',
          default_value:'',
          options: this.options,
          accept:'',
      });
    },
    removeChamps(record){
      this.payload.splice(record, 1);
    },
     checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
  },
  created() {
    this.checkisDashboard();
  },
  mounted(){
     this.get();
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
  },

}
</script>

<style scoped>
.circular--square {
  border-radius: 50%;
}

.circular--square {
  border-radius: 50% 50%;
  width: 50px;
  height: 50px;
  object-fit: contain;
}

svg:not(:host).svg-inline--fa, svg:not(:root).svg-inline--fa {
  font-size: 20px;
}
</style>
